import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "Play_Icon",
  "data-name": "Play Icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 119.319 120.612"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      id: "Group_312",
      "data-name": "Group 312"
    }, [
      _createElementVNode("path", {
        fill: "#fff",
        id: "Path_219",
        "data-name": "Path 219",
        d: "M59.105,7.388c13.853,0,27.89,5.726,37.31,15.146a53.668,53.668,0,0,1,15.515,37.31c0,14.222-5.726,28.444-15.146,37.864a55.133,55.133,0,0,1-37.864,15.515c-13.3,0-27.152-6.1-37.31-16.069C12.375,87.919,7.2,74.436,7.2,59.844A51.974,51.974,0,0,1,22.164,23.088c10.343-9.974,23.642-15.7,36.941-15.7m0-7.388C42.851,0,27.89,7.2,17.177,17.916A59.2,59.2,0,0,0,0,59.844C0,76.1,5.911,91.613,16.623,102.326s26.228,18.286,42.482,18.286a62.338,62.338,0,0,0,43.036-17.732c10.713-10.713,17.177-26.782,17.177-43.036a61.446,61.446,0,0,0-17.732-42.667A60.655,60.655,0,0,0,59.105,0Z"
      })
    ], -1),
    _createElementVNode("g", {
      id: "Group_313",
      "data-name": "Group 313",
      transform: "translate(43.775 37.68)"
    }, [
      _createElementVNode("path", {
        fill: "#fff",
        id: "Path_220",
        "data-name": "Path 220",
        d: "M24.439,42.379c0-10.159-.739-10.159-.739-20.133,0-1.478,2.216-2.216,3.509-1.662,8.681,4.987,8.5,5.541,17.177,10.528s9.42,3.879,18.1,9.051c1.293.739.739,2.771-.554,3.509-8.681,4.987-8.312,5.911-16.993,11.082L27.579,65.1c-1.293.739-2.955-.924-2.955-2.4C24.624,52.538,24.439,52.538,24.439,42.379Z",
        transform: "translate(-23.7 -20.4)"
      })
    ], -1)
  ])))
}
export default { render: render }